import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import { App } from 'components';
import 'bootstrap/dist/css/bootstrap.css';
import {BrowserRouter as Router} from 'react-router-dom'
import { positions } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

//const store2 = createStore(cartReducer);
const options = {
  timeout: 5000,
 position: positions.BOTTOM_CENTER
};

ReactDOM.render(
  <Provider store={store} template={AlertTemplate} {...options}>
     >
  <Router>
    <App />
    </Router>
  </Provider>
  ,
  document.getElementById('root')
);
